// Helper i18n minimale condiviso dai tool (CV Builder, interesse composto, ...).
// Le chiavi sono le stringhe italiane originali: una voce mancante nel dizionario
// degrada in italiano invece di rompere la UI.
//
// Uso:
//   import { t, PAGE_LANG, UI_LOCALE, langPath, registerTranslations } from './i18n.js';
//   registerTranslations(MY_EN_DICT); // una volta, all'init del modulo
//   t('Annulla')                        -> 'Cancel' su pagine EN, 'Annulla' su pagine IT
//   t('Mancano {n} immagini', { n: 3 }) -> interpolazione {placeholder} in entrambe le lingue

const docLang = (typeof document !== 'undefined' && document.documentElement?.lang) || '';
const pathIsEn =
  typeof location !== 'undefined' &&
  (location.pathname === '/en' || location.pathname.startsWith('/en/'));

export const PAGE_LANG = docLang.toLowerCase().startsWith('en') || (!docLang && pathIsEn) ? 'en' : 'it';
export const UI_LOCALE = PAGE_LANG === 'en' ? 'en-GB' : 'it-IT';

const EN_DICT = {};

export function registerTranslations(map) {
  if (map && typeof map === 'object') Object.assign(EN_DICT, map);
}

export function t(str, vars) {
  let out = PAGE_LANG === 'en' ? (EN_DICT[str] ?? str) : str;
  if (vars) {
    out = out.replace(/\{(\w+)\}/g, (match, key) => (key in vars ? String(vars[key]) : match));
  }
  return out;
}

// Prefissa /en ai path interni quando la pagina è inglese (link editor, success URL Stripe, ...).
export function langPath(path) {
  return PAGE_LANG === 'en' ? `/en${path}` : path;
}
